/*eslint no-prototype-builtins: "error"*/
import Vue from 'vue';
import { hasPropertiesInObject } from '@src/utils/validations.js';

// default state variable with all the possible variables and types it can accept
const step3 = {
    quotationStatusId: -1,
    quotationRejectionId: -1,
    rejectionDescription: 'string',
    quotationFormEmail: {
        entityName: 'string',
        contactName: 'string',
        phone: 'string',
        nif: 'string',
        km: 0,
        processNumber: 'string',
        simulationNumber: 'string',
        email: 'string'
    },
    quotationWorks: [
        /**
        {
            "workId": "string",
            "itemMpId": "string",
            "reference": "string",
            "moValue": 0,
            "quotationLaborId": 0,
            "discountMobyLine": 0,
            "partialPriceMO": 0
        }
         */
    ],
    quotationParts: [
        /**
        {
            "reference": "string",
            "itemMpId": "string",
            "discountPartsByLine": 0,
            "quantity": 0,
            "price": 0, // final part price w/o IVA
            "editedPrice": 0, // price box whose value can be edited
            "isIam": true
        }
         */
    ],
    quotationValueIAM: {
        isSelected: true,
        subTotalHoursMO: 0,
        subTotalValueMO: 0,
        subTotalDiscountMO: 0,
        netTotalMO: 0,
        subTotalValueParts: 0,
        subTotalDiscountParts: 0,
        netTotalParts: 0,
        totalSIVA: 0,
        ivAtotal: 0,
        totalCIVA: 0
    },
    quotationValueOE: {
        isSelected: true,
        subTotalHoursMO: 0,
        subTotalValueMO: 0,
        subTotalDiscountMO: 0,
        netTotalMO: 0,
        subTotalValueParts: 0,
        subTotalDiscountParts: 0,
        netTotalParts: 0,
        totalSIVA: 0,
        ivAtotal: 0,
        totalCIVA: 0
    },
    quotationMargins: [
        /**
        {
            "moCostPrice": 0,
            "moSellPrice": 0,
            "moMargin": 0,
            "moMarginPercentage": 0,
            "partCostPrice": 0,
            "partSellPrice": 0,
            "partMargin": 0,
            "partMarginPercentage": 0,
            "iamOperationCost": 0,
            "iampvp": 0,
            "iamMargin": 0
        }
         */
    ],
};

const budgetSummary = {
    operations: {
        values: [
            // {
            //     reference,
            //     name,
            //     hourValue,
            //     duration,
            //     discount,
            //     totalWithoutVAT
            // },
            // ...
        ],
        totals: {
            // totalDuration,
            // globalDiscount,
            // totalWithoutDiscount,
            // totalWithDiscount
        }
    },
    parts: {
        values: [],
        totals: {
            // TODO: Initialize all
            totalOeOnlyWithDiscount: 0, // This is very important to initialize
            // globalDiscount,
            // totalWithoutDiscount,
            // totalWithDiscount,
        }
    },
    totals: {
        oe: {
            // totalOperations,
            // totalParts,
            // totalWithoutVAT,
            // vat,
            // total,
        },
        iam: {
            // totalOperations,
            // totalParts,
            // totalWithoutVAT,
            // vat,
            // total,
        }
    },
    lastBudgetSelectedToCompare: null,
    newBudgetToCompare: null,
    quotationMargins: [],
    stateForTotalizersCalcsOE: [],
    stateForTotalizersCalcsOeTotals: {},
    stateForTotalizersCalcsIAM: [],
    stateForTotalizersCalcsIamTotals: {},
    stateClientInfo: {},
    statePackageServices: [],
    stateSelectedPackageServices: []
};

// initial state
const state = () => ({
    /**
     * Objeto de controle isolado
     * para os tratamentos B2B
     *
     * @description Atenção para o ciclo de vida deste modulo
     *              Tudo que é preciso para o budget está sendo controlado
     *              apenas por este objeto.
     *
     *              Este objeto está sendo mantido também no localstorage,
     *              A página inicial do budget se encarrega de checar se
     *              existe a variavel "budgetB2b" no localstorage, caso
     *              exista é recuperado e setado novamente neste objeto
     *              no "state.b2b".
     */
    b2b: {
        /**
         * Object responsável por todo o controlle do carrinho do budget
         * Somente dele que é consultado valores e alterado valores.
         * Não existe alteração de valores em componentes, todos valores
         * alterados por exemplo de preços são alterados aqui.
         *
         * @description Existe a funcionalidade de realizar o restore de um registro
         *              contido no carrinho, para que isso seja possivel, os valores
         *              obtidos dos serviços são imutaveis, quando um valor sofre
         *              alteração é criado uma nova propriedade em tempo de execução
         *              adicionando o novo valor.
         *
         * @param {object} shoppingCart Controle do carrinho de compras
         *
         * @param  {object} operations                Encapsulatador dos objetos das operações
         * @param  {object} operations.maintenance    Contem os itens referente as operações de manutenção
         * @param  {object} operations.repair         Contem os itens referente as operações de reparação
         */
        totalsIamCost:[],
        shoppingCart: {
            operations: {
                maintenance: [],
                repair: []
            },
            parts: [],
            numberOfChanges: 0,
            needToCheckItemMpId: null,
            lastDeletedItem: '',
        },

        /**
         * Contains all the information relative to the budget, containing all its operations, parts and totals info
         */
        budgetSummary: budgetSummary,

        /**
         * Responsavel pelo controle do step do orçamento em exibição com inicialização
         * null para componentes que acessam de outras partes do projeto, quando é
         * inicializado a navegação normal no budget é setado inicialmente com 1,
         * portanto se for null passa para o último step
         *
         * @param {number} [currentStep = null] Variavel com o controle do passo atual
         */
        currentStep: null,

        /**
         * Valor de mão de obra utilizado em todos calculos do budget
         * Atualmente o único local que faz o set é o component shoppingCart
         *
         * @type {object}
         */
        laborValue: {
            isFavourite: null,
            value: {}
        },

        /**
         * Controles dos steps em curso do orçamento.
         *
         * @param {object} step1 Objeto contendo informações do step 1
         * @param {object} step2 Objeto contendo informações do step 2
         * @param {object} step3 Objeto contendo informações do step 3, que vai ser enviado para o backend
         */
        step1: {},
        step2: {},
        step3: step3,

        /**
         * Responsavel pelo controle do component plano de serviço
         *
         * @type null|object
         */
        servicePlan: {},

        /**
         * Responsavel pela obtenção do html do MaintenancePlanHtml
         *
         * @param {object}  maintenancePlanHtml               Objeto de controle do component maintenancePlanHtml
         * @param {string}  maintenancePlanHtml.vehicleToken  Objetenção do token para a chamda do serviço
         * @param {boolean} maintenancePlanHtml.show          Controle para mostrar e ocultar
         * @param {string}  maintenancePlanHtml.html          Retorno do serviço contendo a página html
         */
        maintenancePlanHtml: {
            show: false,
            id: 0,
            callRmi: false,
            rmiIdentifier: ''
        },

        currentProcessNumberByCar: null,

        shoppingCartCopy: {
            operations: [],
            parts: [],
        },

        budgetStartedBy: {
            budgetId: null,
            budgetName: '',
        },

        shoppingCartTotals: {
            operations: {
                totals: {}
            },
            parts: {
                totals: {}
            }
        },

        quotationType: {},

        clutchKit: {
          show: false,
          data: null,
          options: [],
          removePartIDs: []
        }
    },
});

// getters
const getters = {
    getState(state) {
        return state;
    },

    /**
     * Métodos B2B
     */

    getShoppingCartCopy(state) {
        return state.b2b.shoppingCartCopy;
    },

    getShoppingCartTotals(state) {
        return state.b2b.shoppingCartTotals;
    },

    getStateB2b(state) {
        return state.b2b;
    },

    getB2bLaborValue(state) {
        return state.b2b.laborValue;
    },

    getB2bLaborValues(state) {
        if(Array.isArray(state.b2b.laborValue.value)){
            return state.b2b.laborValue.value.map(v => {

                return {
                    ...v,
                    id: v.quotationLaborId
                };
            });
        }else{
            return []
        }

    },

    getB2bFavouriteLaborValue(state, getters) {
        return Object.values(getters.getB2bLaborValues).find(value => value.isFavourite && !value.isIAM);
    },

    getParametersForCalculations(state) {
        return state.b2b.shoppingCart.parametersForCalculations;
    },

    getParametersOperationsForCalculations(state) {
        return state.b2b.shoppingCart.parametersForCalculations.operations;
    },

    getParametersPartsForCalculations(state) {
        return state.b2b.shoppingCart.parametersForCalculations.parts;
    },

    getParametersPartsForCalculationsDiscountTotal(state) {
        return state.b2b.shoppingCart.parametersForCalculations.partsDiscountTotal;
    },

    getB2bCurrentShoppingCart(state) {
        return state.b2b.shoppingCart;
    },

    getB2bChangedShoppingCart(state) {
        return state.b2b.shoppingCart.numberOfChanges;
    },

    getB2bWatchNeedToCheckItemMpId(state) {
        return state.b2b.shoppingCart.needToCheckItemMpId;
    },

    getB2bCurrentStep(state) {
        return state.b2b.currentStep;
    },

    getB2bStep1(state) {
        return state.b2b.step1;
    },

    getB2bStep2(state) {
        return state.b2b.step2;
    },

    getB2bStep3(state) {
        return state.b2b.step3;
    },

    getB2bShowMaintenancePlanHtml(state) {
        return state.b2b.maintenancePlanHtml.show;
    },

    getLastDeletedShoppingCartItem(state) {
        return state.b2b.shoppingCart.lastDeletedItem;
    },

    getCurrentProcessNumberByCar(state) {
        return state.b2b.currentProcessNumberByCar;
    },

    getLastBudgetSelectedEditToCompare(state) {
        return state.b2b.budgetSummary.lastBudgetSelectedToCompare;
    },

    getNewBudgetToCompare(state) {
        return state.b2b.budgetSummary.newBudgetToCompare;
    },

    getBudgetSummary(state) {
        return state.b2b.budgetSummary;
    },

    getBudgetStartedBy(state) {
        return state.b2b.budgetStartedBy;
    },

    getBudgetPayloadForTotalizersCalcsOE(state) {
        return state.b2b.budgetSummary.stateForTotalizersCalcsOE;
    },

    getBudgetPayloadForTotalizersCalcsIAM(state) {
        return state.b2b.budgetSummary.stateForTotalizersCalcsIAM;
    },

    getBudgetPayloadForTotalizersCalcsTotalsOE(state) {
        return state.b2b.budgetSummary.stateForTotalizersCalcsOeTotals;
    },

    getStateClientInfo(state, payload) {
        return state.b2b.budgetSummary.stateClientInfo;
    },

    getStatePackageServices(state) {
        return state.b2b.budgetSummary.statePackageServices;
    },

    getStatePackageServicesSelected(state) {
        return state.b2b.budgetSummary.stateSelectedPackageServices;
    },

    getStateOfClutchKit(state) {
      return state.b2b.clutchKit;
    },
    getCalcCost(state) {
        return state.b2b.budgetSummary.quotationMargins
    },
    getQuotationType(state) {
        return state.b2b.quotationType
    }
};

// actions
const actions = {
    updateLocalStorage(state) {
        localStorage.setItem('budgetB2b', JSON.stringify(state.getters.getStateB2b));
    },
    updateLocalStorageShoppingCartCopy(state) {
        localStorage.setItem('@copyShoppingCart', JSON.stringify(state.getters.getStateB2b.shoppingCartCopy));
    },
    updateLocalStorageShoppingCartTotals(state) {
        localStorage.setItem('@shoppingCartTotals', JSON.stringify(state.getters.getStateB2b.shoppingCartTotals));
    },
};

// mutations
const mutations = {
    /**
     * Métodos B2B
     */

    setB2bShowMaintenancePlanHtml(state, payload) {
        if(payload.callRmi) {
          state.b2b.maintenancePlanHtml = {
            show: payload.show,
            id: payload.id,
            callRmi: payload.callRmi,
            rmiIdentifier: payload.rmiIdentifier
          };
        } else {
          state.b2b.maintenancePlanHtml = {
            show: payload.show,
            id: payload.id
          };
        }
    },

    setCalcCost(state, payload){
        state.b2b.budgetSummary.quotationMargins = payload
    },

    setShoppingCartCopy(state, payload) {
        state.b2b.shoppingCartCopy = payload;

        let copyPayload = payload;
        copyPayload.operations.map(item =>
          Object.assign(item, {kindOfPosition: item.showServicePlan ? item.showServicePlan : item.kindOfPosition ? item.kindOfPosition : ''})
        )

        localStorage.setItem('@copyShoppingCart', JSON.stringify(copyPayload));
    },

    setShoppingCartTotals(state, payload) {
        if(payload.isOp) {
            state.b2b.shoppingCartTotals.operations.totals = payload.totals;
        } else {
            state.b2b.shoppingCartTotals.parts.totals = payload.totals;
        }
        let newPayload = _.cloneDeep(state.b2b.shoppingCartTotals)
        localStorage.setItem('@shoppingCartTotals', JSON.stringify(newPayload));
    },

    setShoppingCartTotalsClear(state, payload) {
        state.b2b.shoppingCartTotals = payload;
        localStorage.setItem('@shoppingCartTotals', JSON.stringify(payload));
    },

    putOperationToBudgetSummary(state, operationRow) {
        if (!hasPropertiesInObject(['itemMpId', 'workId', 'names', 'hourValue', 'duration', 'discount', 'totalWithoutVAT', 'description', 'calculatedTime'], operationRow))
            throw new Error('budgetStore -> putOperationToBudgetSummary -> operationRow is missing a property');

        const alreadyExistsIndex = state.b2b.budgetSummary.operations.values.findIndex(
            operation => operationRow.workId == operation.workId
        );

        if (alreadyExistsIndex >= 0) {
            Vue.set(state.b2b.budgetSummary.operations.values, alreadyExistsIndex, operationRow);
        } else {
            state.b2b.budgetSummary.operations.values.push(operationRow);
        }
    },

    setOperationTotalsToBudgetSummary(state, operationsTotals) {
        if (!hasPropertiesInObject(['totalDuration', 'globalDiscount', 'totalWithoutDiscount', 'totalWithDiscount'], operationsTotals))
            throw new Error('budgetStore -> setOperationTotalsToBudgetSummary -> operationRow is missing a property');

        state.b2b.budgetSummary.operations.totals = Object.assign({}, operationsTotals);
    },

    putPartToBudgetSummary(state, partRow) {
        if (
            !hasPropertiesInObject(
                ['itemMpId', 'reference', 'brand', 'brandId','name', 'isIam', 'price', 'quantity', 'discount', 'totalWithoutVAT'],
                partRow
            )
        ) {
            throw new Error('budgetStore -> putPartToBudgetSummary -> partRow is missing a property');
        }

        const parts = state.b2b.budgetSummary.parts;
        const alreadyExistsIndex = parts.values.findIndex(part => partRow.itemMpId == part.itemMpId);

        if (alreadyExistsIndex >= 0) {
            Vue.set(state.b2b.budgetSummary.parts.values, alreadyExistsIndex, partRow);
        } else {
            state.b2b.budgetSummary.parts.values.push(partRow);
        }

        this.dispatch('budget/updateLocalStorage');
    },

    setPartTotalsToBudgetSummary(state, partsTotals) {
        if (!hasPropertiesInObject(['globalDiscount', 'totalWithoutDiscount', 'totalWithDiscount'], partsTotals))
            throw new Error('budgetStore -> setPartTotalsToBudgetSummary -> partRow is missing a property');

        state.b2b.budgetSummary.parts.totals = Object.assign(
            {},
            {
                ...state.b2b.budgetSummary.parts.totals,
                ...partsTotals
            }
        );
    },

    setFinalTotalsToBudgetSumamry(state, { finalTotals, type }) {
        if (!hasPropertiesInObject(['totalOperations', 'totalParts', 'totalWithoutVAT', 'vat', 'total'], finalTotals))
            throw new Error('budgetStore -> setFinalTotalsToBudgetSumamry -> missing a property');

        if (['oe', 'iam'].indexOf(type) < 0) throw new Error('budgetStore -> setFinalTotalsToBudgetSumamry -> type must be "oe" or "iam"');

        state.b2b.budgetSummary.totals[type] = finalTotals;
        this.dispatch('budget/updateLocalStorage');
    },

    setB2b(state, payload) {
        for (var [key, value] of Object.entries(payload)) {
            state.b2b[key] = value;
        }
        state.b2b.shoppingCart.numberOfChanges++;
        this.dispatch('budget/updateLocalStorage');
    },

    setB2bCurrentStep(state, step) {
        state.b2b.currentStep = step;
        this.dispatch('budget/updateLocalStorage');
    },

    setB2bLaborValue(state, labor) {
        state.b2b.laborValue = labor;
        this.dispatch('budget/updateLocalStorage');
    },

    setB2bShoppingCart(state, payload) {
        for (var [key, value] of Object.entries(payload)) {
            state.b2b.shoppingCart.operations[key] = value;
        }

        state.b2b.shoppingCart.numberOfChanges++;
        this.dispatch('budget/updateLocalStorage');
    },

    setParametersOperationsForCalculations(state, payload) {
        const objectName = Object.getOwnPropertyNames(payload)[0];
        const objectItem = payload[Object.getOwnPropertyNames(payload)];
        const objectName2 = Object.getOwnPropertyNames(payload[objectName])[0];

        if (state.b2b.shoppingCart.parametersForCalculations.operations.hasOwnProperty([objectName])) {
            state.b2b.shoppingCart.parametersForCalculations.operations[objectName][objectName2] =
                objectItem[Object.getOwnPropertyNames(objectItem)];
        } else {
            state.b2b.shoppingCart.parametersForCalculations.operations[objectName] = {
                [objectName2]: objectItem[Object.getOwnPropertyNames(objectItem)]
            };
        }

        state.b2b.shoppingCart.numberOfChanges++;
        this.dispatch('budget/updateLocalStorage');
    },

    setParametersPartsForCalculations(state, payload) {
        state.b2b.shoppingCart.parametersForCalculations.parts = payload;

        state.b2b.shoppingCart.numberOfChanges++;
        this.dispatch('budget/updateLocalStorage');
    },

    setParametersPartsForCalculationsDiscountTotal(state, payload) {
        state.b2b.shoppingCart.parametersForCalculations.partsDiscountTotal = payload;

        state.b2b.shoppingCart.numberOfChanges++;
        this.dispatch('budget/updateLocalStorage');
    },

    setB2bResetNeedToCheckItemMpId(state) {
        state.b2b.shoppingCart.needToCheckItemMpId = null;
        this.dispatch('budget/updateLocalStorage');
    },

    setB2bForceReloadShoppingCart(state) {
        state.b2b.shoppingCart.numberOfChanges++;
        this.dispatch('budget/updateLocalStorage');
    },

    setB2bRemoveOrAddShoppingCartItem(state, payload) {
        // if (!isPayloadValid(payload))
        //     throw new Error('Store module budget -> mutation setB2bRemoveOrAddShoppingCartItem ::=> requires a specific payload');

        let addItem = true;
        let isDuplicate = false;
        let newArray = [];

        // check all cart items. if they are not the item we're trying to add, add them to a new array
        // so we add to a new array every item that is different from the one we're trying to add
        state.b2b.shoppingCart.operations[payload.type].filter((item, index) => {
            if (String(item.workId) !== String(payload.item.workId)) {
                newArray.push(item);
            } else {
                addItem = false;
            }
        });

        // if we added every item, and there was no problem, now check if the mapId is not duplicate
        if (addItem) {
            // verifica se não tem duplicidade ao add novo item no carrinho
            state.b2b.shoppingCart.operations[payload.type].filter((item, index) => {
                if (String(item.workId) !== String(payload.item.workId) && String(item.itemMpId) === String(payload.item.itemMpId)) {
                    isDuplicate = true;
                }
            });

            newArray.push(payload.item);
        }

        /**
         * Tratamento para a seguinte verificação de duplicidade:
         *
         * 1) caso acha duplicidade não altera o stado do carrinho,
         *    atualiza a variavel que está ocorrendo watch para reagir no modal
         *
         * 2) caso contrario altera o estado do carrinho
         */
        if (isDuplicate) {
            state.b2b.shoppingCart.needToCheckItemMpId = payload;
        } else {
            state.b2b.shoppingCart.operations[payload.type] = newArray;
            state.b2b.shoppingCart.numberOfChanges++;
        }



        //#######################COPY

        // check all cart items. if they are not the item we're trying to add, add them to a new array
        // so we add to a new array every item that is different from the one we're trying to add
        if(state.b2b.shoppingCartCopy.operations.length > 0){
            if (!addItem) {
                state.b2b.shoppingCartCopy.operations = state.b2b.shoppingCartCopy.operations.filter(el => String(el.workId) != String(payload.item.workId))
                state.b2b.shoppingCartCopy.parts = []
                this.dispatch('budget/updateLocalStorageShoppingCartCopy');

            }

        }


        if(state.b2b.budgetSummary.operations.values.length > 0){
            if (!addItem) {
                state.b2b.budgetSummary.operations.values = state.b2b.budgetSummary.operations.values.filter(el => String(el.workId) != String(payload.item.workId))
            }

        }
        //###########################




        this.dispatch('budget/updateLocalStorage');

        function isPayloadValid(payload) {
            if (!payload.type) {
                console.error('[ERROR] budget -> store -> setB2bRemoveOrAddShoppingCartItem ::=> missing type property');
                return false;
            }
            if (payload.type !== 'maintenance' && payload.type !== 'repair') {
                console.error("[ERROR] budget -> store -> setB2bRemoveOrAddShoppingCartItem ::=> type must be 'maintenance' or 'repair'");
                return false;
            }
            if (!payload.item) {
                console.error('[ERROR] budget -> store -> setB2bRemoveOrAddShoppingCartItem ::=> an item must be provided');
                return false;
            }
            if (!payload.item.workId) {
                console.error('[ERROR] budget -> store -> setB2bRemoveOrAddShoppingCartItem ::=> missing workId property');
                return false;
            }
            // if (!payload.item.workPosDescription) {
            //     console.error('[ERROR] budget -> store -> setB2bRemoveOrAddShoppingCartItem ::=> missing workPosDescription property');
            //     return false;
            // }
            /*if (!payload.item.workPosCriteriaDescription) {
                console.error(
                    '[ERROR] budget -> store -> setB2bRemoveOrAddShoppingCartItem ::=> missing workPosCriteriaDescription property'
                );
                return false;
            }*/
            if (payload.item.singleWorkTime === null || payload.item.singleWorkTime === undefined) {
                console.error('[ERROR] budget -> store -> setB2bRemoveOrAddShoppingCartItem ::=> missing singleWorkTime property');
                return false;
            }

            return true;
        }
        this.dispatch('budget/updateLocalStorage');
    },

    setB2bClearShoppingCartToStep2(state) {
        state.b2b.shoppingCart.operations.maintenance = [];
        state.b2b.shoppingCart.operations.repair = [];
    },

    setB2bClearShoppingCart(state) {
        state.b2b.shoppingCart = {
            operations: {
                maintenance: [],
                repair: []
            },
            parts: [],
            parametersForCalculations: {
                operations: [],
                parts: {},
                partsDiscountTotal: 0
            },
            numberOfChanges: 0,
            needToCheckItemMpId: null
        };

        state.b2b.step1 = {};
        state.b2b.step2 = {};
        Object.assign(state.b2b.step3, step3);
        state.b2b.budgetSummary = {
            operations: {
                values: [
                    // {
                    //     reference,
                    //     name,
                    //     hourValue,
                    //     duration,
                    //     discount,
                    //     totalWithoutVAT
                    // },
                    // ...
                ],
                totals: {
                    // totalDuration,
                    // globalDiscount,
                    // totalWithoutDiscount,
                    // totalWithDiscount
                }
            },
            parts: {
                values: [],
                totals: {
                    // TODO: Initialize all
                    totalOeOnlyWithDiscount: 0, // This is very important to initialize
                    // globalDiscount,
                    // totalWithoutDiscount,
                    // totalWithDiscount,
                }
            },
            totals: {
                oe: {
                    // totalOperations,
                    // totalParts,
                    // totalWithoutVAT,
                    // vat,
                    // total,
                },
                iam: {
                    // totalOperations,
                    // totalParts,
                    // totalWithoutVAT,
                    // vat,
                    // total,
                }
            },
            lastBudgetSelectedToCompare: null,
            newBudgetToCompare: null,
        };

        state.b2b.currentStep = 1;

        state.b2b.shoppingCart.numberOfChanges++;

        localStorage.removeItem('budgetB2b');
    },

    setB2bClearStep1(state) {
        state.b2b.step1 = {};
    },

    setB2bClearStep3(state) {
        state.b2b.step3 = step3;
    },

    setB2bStep3(state, newStep3) {
        state.b2b.step3 = Object.assign({}, newStep3);
    },

    setB2bKM(state, km) {
        state.b2b.step1 = Object.assign({}, km);
    },

    setLastDeletedShoppingCartItem(state, item) {
        state.b2b.shoppingCart.lastDeletedItem = item;
    },

    setBudgetSummaryOperationsValues(state, payload) {
        state.b2b.budgetSummary.operations.values = payload;
        this.dispatch('budget/updateLocalStorage');
    },

    setBudgetSummaryPartsValues(state, payload) {
        state.b2b.budgetSummary.parts.values = payload;
        this.dispatch('budget/updateLocalStorage');
    },

    setBudgetSummaryPartsValuesWhenDelete(state, payload) {
      let myPayload = payload.data.filter(p => String(p.workId) !== String(payload.workIdToDelete));
      if(payload.itemMpIdToDelete) {
        myPayload = myPayload.filter(p => String(p.itemMpId) !== String(payload.itemMpIdToDelete));
      }
      state.b2b.budgetSummary.parts.values = myPayload;
      this.dispatch('budget/updateLocalStorage');
  },

    setBudgetSummaryPartsTotalOeOnlyWithDiscount(state, total) {
        state.b2b.budgetSummary.parts.totals.totalOeOnlyWithDiscount = total;
    },

    setMaintenanceShoppingCartOperations(state, payload) {
        state.b2b.shoppingCart.operations.maintenance = payload;
        this.dispatch('budget/updateLocalStorage');
    },

    setMaintenanceShoppingCartParts(state, payload) {
        state.b2b.shoppingCart.parts = payload;
    },

    setMaintenanceShoppingCartPartsOnDeleteFreePart(state, payload) {
      state.b2b.shoppingCart.parts = payload;
      this.dispatch('budget/updateLocalStorage');
  },

    setB2bShoppingCartNumberOfParts(state) {
        state.b2b.shoppingCart.numberOfChanges++;
        this.dispatch('budget/updateLocalStorage');
    },

    setCurrentProcessNumberByCar(state, payload) {
        state.b2b.currentProcessNumberByCar = payload;
    },

    setClearBudgetSummary(state) {
        state.b2b.budgetSummary = {
            operations: {
                values: [],
                totals: {}
            },
            parts: {
                values: [],
                totals: {
                    totalOeOnlyWithDiscount: 0, // This is very important to initialize
                }
            },
            totals: {
                oe: {},
                iam: {}
            },
            lastBudgetSelectedToCompare: null,
            newBudgetToCompare: null,
        };

        Vue.nextTick(() => {
            state.b2b.budgetSummary = {
                operations: {
                    values: [],
                    totals: {}
                },
                parts: {
                    values: [],
                    totals: {
                        totalOeOnlyWithDiscount: 0, // This is very important to initialize
                    }
                },
                totals: {
                    oe: {},
                    iam: {}
                },
                lastBudgetSelectedToCompare: null,
                newBudgetToCompare: null,
            };
        });
    },

    setLastBudgetSelectedToCompare(state, payload) {
        state.b2b.budgetSummary.lastBudgetSelectedToCompare = payload;
    },

    setLastBudgetSelectedToCompareId(state, id) {
        state.b2b.budgetSummary.lastBudgetSelectedToCompare.quotationId = id;
    },

    setNewBudgetToCompare(state, payload) {
        state.b2b.budgetSummary.newBudgetToCompare = payload;
    },

    setStateClientInfo(state, payload) {
        state.b2b.budgetSummary.stateClientInfo = payload;
    },

    setStatePackageServices(state, payload) {
        state.b2b.budgetSummary.statePackageServices = payload;
    },

    setStateSelectedPackageServices(state, payload) {
        state.b2b.budgetSummary.stateSelectedPackageServices = payload;
    },

    setStateOfClutchKit(state, payload) {
      state.b2b.clutchKit = payload;
    },

    setBudgetStartedBy(state, payload) {
        state.b2b.budgetStartedBy = payload;
        localStorage.setItem('@datadrive:budgetStartedBy', JSON.stringify(payload));
    },

    setQuotationType(state, payload) {
        state.b2b.quotationType = payload;
        localStorage.setItem('@datadrive:budgetQuotationType', JSON.stringify(payload));
    },

    setBudgetPayloadForTotalizersCalcsIAM(state, payload) {
        if(state.b2b.budgetSummary.stateForTotalizersCalcsIAM !== null && state.b2b.budgetSummary.stateForTotalizersCalcsIAM !== undefined && state.b2b.budgetSummary.stateForTotalizersCalcsIAM && state.b2b.budgetSummary.stateForTotalizersCalcsIAM.length > 0) {
            let filterOperations = state.b2b.budgetSummary.stateForTotalizersCalcsIAM.filter(o => o.workId !== payload.workId);
            filterOperations.push(payload);
            state.b2b.budgetSummary.stateForTotalizersCalcsIAM = filterOperations;
        } else {
            let newArray = [];
            newArray.push(payload);
            state.b2b.budgetSummary.stateForTotalizersCalcsIAM = newArray;
        }
    },

    setBudgetPayloadForTotalizersCalcsOE(state, payload) {
        if(state.b2b.budgetSummary.stateForTotalizersCalcsOE !== null && state.b2b.budgetSummary.stateForTotalizersCalcsOE !== undefined && state.b2b.budgetSummary.stateForTotalizersCalcsOE && state.b2b.budgetSummary.stateForTotalizersCalcsOE.length > 0) {
            let filterOperations = state.b2b.budgetSummary.stateForTotalizersCalcsOE.filter(o => o.workId !== payload.workId);
            filterOperations.push(payload);
            state.b2b.budgetSummary.stateForTotalizersCalcsOE = filterOperations;
        } else {
            let newArray = [];
            newArray.push(payload);
            state.b2b.budgetSummary.stateForTotalizersCalcsOE = newArray;
        }
    },

    setBudgetPayloadForTotalizersAllCalcsIam(state, payload) {
        state.b2b.budgetSummary.stateForTotalizersCalcsIAM = payload;
    },

    setBudgetPayloadForTotalizersAllCalcsOE(state, payload) {
        state.b2b.budgetSummary.stateForTotalizersCalcsOE = payload;
    },

    setBudgetPayloadForTotalizersTotalsCalcsOE(state, payload) {
        state.b2b.budgetSummary.stateForTotalizersCalcsOeTotals = Object.assign({}, payload);
    },

    setBudgetPayloadForTotalizersTotalsCalcsIAM(state, payload) {
        state.b2b.budgetSummary.stateForTotalizersCalcsIamTotals = Object.assign({}, payload);
    },

    setShoppingCartOperationsMaintenance(state, payload) {
        state.b2b.shoppingCart.operations.maintenance = payload;
    },

    setShoppingCartOperationsRepair(state, payload) {
        state.b2b.shoppingCart.operations.repair = payload;
    },

    setForceShoppingCart(state, payload) {
      state.b2b.shoppingCart = payload;
      this.dispatch('budget/updateLocalStorage');
    },

    setUpdateShoppingCartParts(state, payload) {
      state.b2b.shoppingCart.parts = payload;
      this.dispatch('budget/updateLocalStorage');
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
